/**
 * For non-catalyst pages to show banners.
 */
 (function($) {
  'use strict';

  // Set up zr for pages that don't have it
  window.zr = window.zr || {
    page: {
      model: {}
    }
  };

  window.zr.page = window.zr.page || { model: {} };

  var params = window.zr.page.model.getAutoBanners || {};

  // Special case for testing truste cookie banner inside the US
  if (document.location.href.indexOf('show_truste_banner=1') !== -1) {
    params['show_truste_banner'] = 1;
  }

  // Add current path for non-global modals
  params['modals_for_url'] = window.location.pathname.substr(1); // Remove leading slash in path

  // if starterview isn't running, this endpoint would always return 502, in which case we want to limit our retries
  var requestLimit = 10;

  // Use this option when you have one js file which depends on another (e.g. jquery.automodal depending on jquery.cookie loading first).
  var downloadAutobannerDepsSequentially = false;
  if (zr.page.model.downloadAutobannerDepsSequentially) {
    downloadAutobannerDepsSequentially = true;
  }

  // Allows for downloading script tags sequentially in case that one script depends on another
  var deferAjax = function(scriptsToDownload) {
    // make shallow clone so we can mutate
    var scripts = scriptsToDownload.concat();

    function next() {
      var script = scripts.shift();
      if (!script) { return; }

      $.ajaxSetup({ cache: true });
      $.ajax(script)
        .done(next)
        .fail(next);
    }
    next();
  };

  // Check privacy policy endpoint
  var getAutoBanners = function() {
    $.ajax((zr.page.model.url_prefix ? zr.page.model.url_prefix : '') + '/get-auto-banners?', {
      data: params,
    })
      .done(function(data) {
        if (data && data.html) {
          var html = $.trim(data.html);
          if (!html) { return; }
          $(document.body).append(html);

          // Fire a custom event so other files will know when modal is done loading
          var event = new Event('ModalLoaded');
          document.dispatchEvent(event);

          var $el = $('.get-auto-banners');
          var fetchParams = {
            dataType: 'script',
          };
          var cspNonce = window.zr.page.model.cspNonce;

          if (cspNonce) {
            Object.assign(fetchParams, {
              scriptAttrs: { nonce: cspNonce },
            });
          }

          var scriptsToDownload = [];

          $el.find('link[rel="x-javascript"]').each(function() {
            var $this = $(this);

            // eslint-disable-next-line prefer-object-spread
            var newScript = Object.assign({
              url: $this.attr('href'),
              success: function() {
                $this.remove();
                delete window.zr.page.model.cspNonce;
              },
            }, fetchParams);
            scriptsToDownload.push(newScript);
          });
          // Download each script sequentially so that each one only downloads and executes after the previous has finished.
          if (downloadAutobannerDepsSequentially) {
            deferAjax(scriptsToDownload);
          } else {
            // fires off separate calls for each script. They may not be loaded in order. This will be a faster option
            scriptsToDownload.forEach(function(script) {
              $.ajax(script);
            });
          }
        }
      })
      .fail(function() {
        requestLimit -= 1;

        if (requestLimit > 0) {
          setTimeout(getAutoBanners, 1000);
        }
      });
  };
  setTimeout(getAutoBanners, 2000);
}(window.jQuery || window.$));
